export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.liveIndicator)+' '+(props.styles.hidden)+'"> <span class="'+(props.styles.liveIndicatorText)+'" aria-label="'+(props.texts.label || '')+'" data-hook="live-indicator-text"> '+(props.texts.text || '')+' </span></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/live-indicator/templates/live-indicator.dot
// module id = 184
// module chunks = 0 1 2 3 4